import React from "react";
import PropTypes from "prop-types";
import ConvertToMoney from "./convert-to-money";
import CampaignGroupPropType from "./campaign-group-prop-type";
import CampaignGroupImagePreview from "./campaign-group-image-preview";

const propTypes = {
  campaignPackage: PropTypes.shape({
    country_iso: PropTypes.string,
    target_savings_percent: PropTypes.number,
    savings_amount: PropTypes.number,
    old_package_interval_adj: PropTypes.string
  }).isRequired,
  campaignGroup: CampaignGroupPropType
};

const UpgradeSellSection = ({ campaignGroup = {}, campaignPackage }) => {
  return (
    <div className="d-flex flex-column align-items-center flex-sm-row align-items-sm-start">
      {campaignGroup && (
        <div className="mr-3">
          <CampaignGroupImagePreview campaignGroup={campaignGroup} />
        </div>
      )}
      <div>
        <h4 className="font-weight-bold">
          Save {Math.round(campaignPackage.target_savings_percent * 100) / 100}% today!
        </h4>
        <p>
          Simply checkout below and the&nbsp;
          {Math.round(campaignPackage.target_savings_percent * 100) / 100}% discount will be applied
          to the entire length of your campaign.
        </p>
        <div className="text-success font-weight-semibold">
          You'll save&nbsp;
          <ConvertToMoney
            number={campaignPackage.savings_amount}
            countryIso={campaignPackage.country_iso}
            className="d-inline m-0 p-0"
          />{" "}
          over continuing {campaignPackage.old_package_interval_adj}
        </div>
      </div>
    </div>
  );
};

UpgradeSellSection.propTypes = propTypes;

export default UpgradeSellSection;
